"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataPxtTelemetryEvents = void 0;
const encoding_1 = require("./encoding");
class DataPxtTelemetryEvents {
    constructor(eventsWithTriggerResourceNames) {
        this.eventAttribute = "data-pxt-telemetry-events";
        this.eventAttributeValue = (0, encoding_1.encode)(eventsWithTriggerResourceNames);
    }
    getEventAttribute() {
        return this.eventAttribute;
    }
    getEventAttributeValue() {
        return this.eventAttributeValue;
    }
}
exports.DataPxtTelemetryEvents = DataPxtTelemetryEvents;
